import NotificationInterface from "@/types_and_interfaces/notification_interface.tsx";
import {useAtom} from "jotai/index";
import {
    notif_current_page,
    open_notifications_sidebar,
    paginated_notifications,
    stored_notifications,
    unread_notif
} from "@/atoms/profile.ts";
import {
    delete_notifications, get_notif_count,
    get_per_pages_notification, get_technical, read_all_notification,
} from "@/services/notifications.ts";
import Factories from "@/utils/factories.ts";
import {popping_notifications} from "@/atoms/common.ts";
import useLoans from "@/hooks/loans.ts";
import useAuth from "@/hooks/auth.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";



function useNotifications() {

    const [pgNotifications, setPgNotifications] = useAtom(paginated_notifications)
    const [storedNotification, setStoredNotifications] = useAtom(stored_notifications)
    const [notifPage, setNotifPage] = useAtom(notif_current_page)
    const [unreadNotif, setUnreadNotif] = useAtom(unread_notif)
    const [openNotifications, setOpenNotifications] = useAtom(open_notifications_sidebar)
    const [ , set_popping_notif] = useAtom(popping_notifications)
    const loan = useLoans()
    const auth = useAuth()

    const updatePaginatedNotifications = async () => {
        
        
        const response = await get_per_pages_notification(notifPage)

        
        if(response.status === 200 && response.message === "ok") {
            
            const raw_notifications = response.response.notifications
            
            let notif_list:Array<NotificationInterface> = raw_notifications.map((x:any) => {
                return Factories.notification_factories(x)
            })
            
            if(response.response?.has_more){
                setNotifPage((x:number) => x + 1)
            }
            
            if(notifPage > 1) {
                if(typeof pgNotifications === "object" && Array.isArray(pgNotifications.notif_list)) {
                    let merged = [...pgNotifications.notif_list, ...notif_list]
                    setPgNotifications({
                        req_err: false,
                        has_more: response.response?.has_more || false,
                        notif_list: merged
                    })
                }
            } else {
                if(Array.isArray(raw_notifications)) {
                    setPgNotifications({
                        req_err: false,
                        has_more: response.response?.has_more || false,
                        notif_list
                    })
                }
            }
        } else {
            
            if(typeof pgNotifications === "object") {
                
                setPgNotifications({
                        ...pgNotifications,
                        req_err: true
                    }
                )
            } else {
                
                setPgNotifications({
                        has_more:false,
                        notif_list:[],
                        req_err: true
                    }
                )
            }
        }
    }
    
    const deleteNotification = async (notification_id:string) => {
        const response = await delete_notifications(notification_id)
        
        if(response.status === 200 && response.message === "ok") {
            await updatePaginatedNotifications()
        }
    }
    
    const update_count = async () => {
        const response = await get_notif_count()
        
        if(response.status === 200 && response.message === "ok") {
            setUnreadNotif(response.response.unread)
            
            if(typeof response.response.technical_unread === "number" && response.response.technical_unread ){
                upd_technical()
            }
            
            if(typeof response?.response?.force_update_loans === "boolean" && response?.response?.force_update_loans){
                upd_technical()
                loan.updateUserLoans()
                loan.updPendingLoans()
            }
            
        } else {
            setUnreadNotif(0)
        }
    }
    
    const upd_technical = async () => {
        const tech = await get_technical()

        if(Array.isArray(tech?.response?.data) && tech?.response?.data.length){
            const raw_notifications = tech?.response?.data
            let notif_list:Array<NotificationInterface> = raw_notifications.map((x:any) => {
                return Factories.notification_factories(x)
            })

            const loans = notif_list.find((x) => x.type === "loan_status_changed")
            const transactions = notif_list.find((x) => x.type === "cr_line_application_status_changed")
            const cr_line_application_status_changed_and_amount_changed = notif_list.find((x) => x.type === "cr_line_application_status_changed_and_amount_changed")
            const restant = notif_list.find((x) => x.type === "loan_installment_after")
            const loan_installment_before = notif_list.find((x) => x.type === "loan_installment_before")
            const loan_payment = notif_list.find((x) => x.type === "loan_payment")
            const added_attempt_liveness = notif_list.find((x) => x.type === "added_attempt_liveness")
            const added_attempt_doc_card = notif_list.find((x) => x.type === "added_attempt_doc_card")
            const identity_card_passed = notif_list.find((x) => x.type === "identity_card_passed")
            const liveness_passed = notif_list.find((x) => x.type === "liveness_passed")
            const loan_data_changed = notif_list.find((x) => x.type === "loan_data_changed")
            const loan_status_changed_not_valid = notif_list.find((x) => x.type === "loan_status_changed_not_valid")
            const reset_kyc = notif_list.find((x) => x.type === "reset_kyc")
            const loan_status_rejected = notif_list.find((x) => x.type === "loan_status_rejected")
            const expire_kyc_30_days = notif_list.find((x) => x.type === "expire_kyc_30_days")
            const expire_kyc_20_days = notif_list.find((x) => x.type === "expire_kyc_20_days")
            const expire_kyc_10_days = notif_list.find((x) => x.type === "expire_kyc_10_days")
            const expire_kyc_5_days = notif_list.find((x) => x.type === "expire_kyc_5_days")
            const expire_kyc_3_days = notif_list.find((x) => x.type === "expire_kyc_3_days")
            const expire_kyc_2_days = notif_list.find((x) => x.type === "expire_kyc_2_days")
            const expire_kyc_1_days = notif_list.find((x) => x.type === "expire_kyc_1_days")
            const asp_kyc_conflict = notif_list.find((x) => x.type === "asp_kyc_conflict")

            if(loans || transactions || loan_status_rejected) {
                loan.updPendingLoans()
                loan.updateUserLoans()
                auth.small_update()
            }
            
            if(
                transactions ||
                cr_line_application_status_changed_and_amount_changed ||
                restant ||
                loan_installment_before ||
                loan_payment ||
                added_attempt_liveness ||
                added_attempt_doc_card ||
                loan_data_changed ||
                loan_status_changed_not_valid
            ) {
                loan.updateUserLoans()
                auth.small_update()

            }

            if((identity_card_passed || liveness_passed || reset_kyc ||
                expire_kyc_30_days ||
                expire_kyc_20_days ||
                expire_kyc_10_days ||
                expire_kyc_5_days  ||
                expire_kyc_3_days  ||
                expire_kyc_2_days  ||
                expire_kyc_1_days  ||
                asp_kyc_conflict
            ) && !location.pathname.includes(DashboardClass.dashboard_routes.KYC)){
                auth.small_update()
            }

            if(identity_card_passed && location.pathname.includes(DashboardClass.dashboard_routes.KYC + "/1")) {
                eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.KYC + "/2")
            }
            
            set_popping_notif((x) => [...x, ...notif_list])
        }
    }
    
    const notification_sidebar_handle = async () => {
        
        if(openNotifications) {
            resetPaginatedNotifications()
            setOpenNotifications(false)
            
        } else {
            
            updatePaginatedNotifications()
            setOpenNotifications(true)
            const sidebar = document.getElementById("notif_scrolling_elem")
            
            if(sidebar){
                sidebar.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                })
            }
            
            if(getUnread()) {
                let timeout = setTimeout(async() => {
                    await read_all_notification()
                    update_count()
                    clearTimeout(timeout)
                }, 500)
            }
        }
    }
    
    // TODO : make propper clears
    const clearNotifications = () => {
        setStoredNotifications(pgNotifications)
        setPgNotifications(undefined)
        setNotifPage(1)
    }
    
    const getNotifications = () => {
        return pgNotifications
    }
    
    const getPgNotifications = () => {
        return pgNotifications
    }
    
    const getUnread = () => {
        return unreadNotif
    }
    
    const resetPaginatedNotifications = () => {
        setPgNotifications(storedNotification)
        setStoredNotifications(undefined)
        setNotifPage(1)
    }
    
    
    return {
        updatePaginatedNotifications,
        deleteNotification,
        clearNotifications,
        getNotifications,
        getPgNotifications,
        update_count,
        resetPaginatedNotifications,
        getUnread,
        notification_sidebar_handle,
        upd_technical
    }
}

export default useNotifications